/****************************************************************
 * WARNING THIS FILE IS AUTOGENERATED AND SHOULD NOT BE MODIFIED *
 ****************************************************************/
import * as React from "react"
import Svg from "@oui/system/Svg"
type DefaultProps = typeof defaultProps
type SvgProps = React.ComponentPropsWithoutRef<typeof Svg>
type Props = DefaultProps &
  Omit<SvgProps, "fill" | "height" | "stroke" | "viewBox" | "width">
const defaultProps = {
  label: "Play Circle",
  size: 20
}

const SvgPlayCircle = ({ size, ...props }: Props) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="currentcolor"
    stroke="currentcolor"
    {...props}
  >
    <path fill="none" strokeWidth={1.1} d="M8.5 7l5 3-5 3z" />
    <circle fill="none" strokeWidth={1.1} cx={10} cy={10} r={9} />
  </Svg>
)

SvgPlayCircle.defaultProps = defaultProps
export default SvgPlayCircle
